module.exports = __webpack_public_path__ + "img/home2.ab7e9db9.jpg";